// Whether a raw permission list grants any permission in a category (e.g.
// 'clients', 'suppliers', 'federated'). Pure so it can resolve a mode straight
// from a freshly fetched permission list, without waiting on a reactive
// observer that may still hold the previous org's permissions after an org
// switch (see the mode store's setModeFromOrg). Kept in its own module so the
// real barrel and its manual mock can share one definition rather than drift.
export function hasPermissionCategory(permissions: string[], category: string): boolean {
  return permissions.some(
    (permission) => permission === '*' || permission.startsWith(`${category}.`),
  );
}
